import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function usePageTracking(measurementId) {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    const { pathname, search } = location;

    const payload = {
      page_path: pathname + search,
      page_location: window.location.href,
      //   page_title: document.title,
      page_title: "Lot Specific Platform",
      send_to: measurementId,
    };

    window.gtag("event", "page_view", payload);
  }, [location, measurementId]);
}
